export const METRIC_SERIES = 'metric-series';
export const DOD_SERIES = 'dod-series';
export const MANUAL_ALERT_SERIES = 'manual-alert-markers';
export const METRIC_FILTER_SERIES = 'metric-filter-series';

export const COMPARE_SERIES_LIMIT = 20;
export const COMPARE_SERIES_PREFIX = 'compare-series';

export const TIME_AXIS = 'time-axis';
export const VALUE_AXIS = 'value-axis';
export const DOD_TIME_AXIS = 'dod-time-axis';
